import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';

// ═══ 말소대행 부가서비스 목록 (작업 유형 탭 안 형제 섹션) ═══
// 대행사가 신청 폼에 노출할 부가서비스(번호판 폐기, 서류 대행 등)를 관리한다.
// 작업 유형(CancelAgencyWorkTypes)과 달리 대행사 자신의 것만 다룬다 — agencyId 선택 없이
// 서버가 로그인한 대행사 기준으로 스코프한다. 대행사 운영자만 편집, 직원은 읽기만.
// 서버(GET /agency-extra-services)가 아직 배포 전이면(404/405) 화면 자체를 숨긴다.
function CancelAgencyExtraServices({ showToast, isCancelAgency, isStaff }) {
  var fmt = function(n){ return (parseInt(n,10)||0).toLocaleString(); };
  var canEdit = isCancelAgency && !isStaff;

  var [items, setItems] = useState([]);
  var [unavailable, setUnavailable] = useState(false);
  var [editing, setEditing] = useState(0);
  var [form, setForm] = useState(null);
  var [add, setAdd] = useState(null);
  var [del, setDel] = useState(null);

  var load = function(){
    authFetch(API+'/agency-extra-services').then(function(r){
      if(r.status===404||r.status===405){ setUnavailable(true); return null; }
      if(!r.ok) throw new Error('HTTP '+r.status);
      return r.json();
    }).then(function(d){ if(d){ setItems(Array.isArray(d)?d:[]); setUnavailable(false); } }).catch(function(){ setItems([]); });
  };
  useEffect(function(){ if(isCancelAgency) load(); }, [isCancelAgency]); // eslint-disable-line react-hooks/exhaustive-deps

  if(!isCancelAgency || unavailable) return null;

  var closeAll = function(){ setEditing(0); setForm(null); };
  var setF = function(k,v){ setForm(function(p){ var n=Object.assign({},p); n[k]=v; return n; }); };
  var setA = function(k,v){ setAdd(function(p){ var n=Object.assign({},p); n[k]=v; return n; }); };

  var send = function(url, method, body, okMsg, after){
    var opt = { method: method };
    if(body){ opt.headers = {'Content-Type':'application/json'}; opt.body = JSON.stringify(body); }
    authFetch(url, opt).then(function(r){ return r.json().catch(function(){ return {}; }); }).then(function(d){
      if(d && d.success){ showToast(d.deactivated ? '사용 중인 항목이라 비활성 처리했습니다' : okMsg); closeAll(); load(); if(after) after(d); return; }
      showToast((d && d.error) || '처리 실패', 'err');
    }).catch(function(){ showToast('처리 실패','err'); });
  };

  var startEdit = function(r){
    setEditing(r.id);
    setForm({ name:r.name||'', defaultFee:String(r.defaultFee||0), issueTaxInvoice:!!r.issueTaxInvoice, sortOrder:String(r.sortOrder||0), active:(r.active?1:0) });
  };
  var save = function(r){
    if(!form.name || !form.name.trim()){ showToast('이름을 입력하세요','err'); return; }
    var body = {
      defaultFee: parseInt(form.defaultFee,10)||0,
      issueTaxInvoice: form.issueTaxInvoice?1:0,
      sortOrder: parseInt(form.sortOrder,10)||0,
      active: form.active?1:0
    };
    if(r.kind!=='reissue') body.name = form.name.trim(); // 시스템 항목(재교부)은 이름 변경 불가
    send(API+'/agency-extra-services/'+r.id, 'PUT', body, '수정 완료');
  };
  var setActive = function(r, active){
    send(API+'/agency-extra-services/'+r.id, 'PUT', {active: active?1:0}, active?'다시 활성화했습니다':'비활성으로 전환했습니다');
  };
  var doDelete = function(){
    send(API+'/agency-extra-services/'+del.id, 'DELETE', null, '삭제 완료', function(){ setDel(null); });
  };
  var move = function(r, dir){
    var sorted = items.slice().sort(function(a,b){return (a.sortOrder||0)-(b.sortOrder||0);});
    var idx = sorted.findIndex(function(x){return x.id===r.id;});
    var swapIdx = idx+dir;
    if(swapIdx<0 || swapIdx>=sorted.length) return;
    var other = sorted[swapIdx];
    authFetch(API+'/agency-extra-services/'+r.id, {method:'PUT',headers:{'Content-Type':'application/json'},body:JSON.stringify({sortOrder:other.sortOrder||0})})
      .then(function(){ return authFetch(API+'/agency-extra-services/'+other.id, {method:'PUT',headers:{'Content-Type':'application/json'},body:JSON.stringify({sortOrder:r.sortOrder||0})}); })
      .then(function(){ load(); }).catch(function(){ showToast('순서 변경 실패','err'); });
  };

  var startAdd = function(){ closeAll(); setAdd({ name:'', defaultFee:'', issueTaxInvoice:false, sortOrder:'' }); };
  var submitAdd = function(){
    if(!add.name || !add.name.trim()){ showToast('이름을 입력하세요','err'); return; }
    send(API+'/agency-extra-services', 'POST', {
      name: add.name.trim(),
      defaultFee: parseInt(add.defaultFee,10)||0,
      issueTaxInvoice: add.issueTaxInvoice?1:0,
      sortOrder: parseInt(add.sortOrder,10)||0
    }, '부가서비스 추가 완료', function(){ setAdd(null); });
  };

  var TH = {fontSize:11,color:'#94a3b8',textAlign:'left',fontWeight:600,padding:'8px 12px',borderBottom:'1px solid #e2e8f0',background:'#f1f5f9'};
  var TD = {padding:'9px 12px',borderBottom:'1px solid #f1f5f9',verticalAlign:'middle'};
  var is = {border:'1px solid #e2e8f0',borderRadius:6,padding:'6px 9px',fontSize:12.5,background:'#fff',color:'#1e293b',width:'100%',boxSizing:'border-box'};
  var ls = {fontSize:11,fontWeight:700,color:'#64748b'};
  var frmSt = {display:'flex',gap:10,flexWrap:'wrap'};
  var modalWrap = {position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.45)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9999,padding:16};
  var modalBox = {background:'#fff',borderRadius:14,padding:20,width:480,maxWidth:'94vw',maxHeight:'90vh',overflowY:'auto',boxShadow:'0 12px 40px rgba(0,0,0,0.18)'};
  var fld = function(label, node, width){
    return (<div style={{display:'flex',flexDirection:'column',gap:3,width:width||undefined,flex:width?undefined:1,minWidth:width?undefined:140}}>
      <label style={ls}>{label}</label>{node}
    </div>);
  };
  var textIn = function(val, on, ph, right){
    return <input value={val} onChange={function(e){on(e.target.value)}} placeholder={ph||''} style={Object.assign({},is,right?{textAlign:'right'}:null)} />;
  };

  var sorted = items.slice().sort(function(a,b){return (a.sortOrder||0)-(b.sortOrder||0);});

  var editFields = function(r){
    var isReissue = r.kind==='reissue';
    return (<React.Fragment>
      <div style={frmSt}>
        {fld('이름', isReissue
          ? <div>
              <input value={form.name} disabled style={Object.assign({},is,{background:'#f1f5f9',color:'#94a3b8'})} />
              <div style={{fontSize:11,color:'#94a3b8',marginTop:4}}>시스템 항목 — 재교부 정산 규칙 적용</div>
            </div>
          : textIn(form.name, function(v){setF('name',v)}, '예: 번호판 폐기'))}
        {fld('기본 금액(원)', textIn(form.defaultFee, function(v){setF('defaultFee',v)}, '0', true), 130)}
        <label style={{display:'flex',alignItems:'center',gap:6,fontSize:12.5,paddingTop:16,whiteSpace:'nowrap'}}>
          <input type="checkbox" checked={!!form.issueTaxInvoice} onChange={function(e){setF('issueTaxInvoice',e.target.checked)}} /> 계산서 포함
        </label>
        <label style={{display:'flex',alignItems:'center',gap:6,fontSize:12.5,paddingTop:16,whiteSpace:'nowrap'}}>
          <input type="checkbox" checked={!!form.active} onChange={function(e){setF('active',e.target.checked?1:0)}} /> 사용
        </label>
      </div>
      <div style={{display:'flex',gap:8,alignItems:'center'}}>
        <button className="btn btn-blue btn-sm" onClick={function(){save(r)}}>저장</button>
        <button className="btn btn-outline btn-sm" onClick={closeAll}>취소</button>
        <div style={{flex:1}} />
        {!isReissue && <button className="btn btn-outline btn-sm" style={{color:'#dc2626'}} onClick={function(){ setDel({id:r.id, name:r.name}); }}>삭제</button>}
      </div>
    </React.Fragment>);
  };

  return (
    <div style={{marginTop:24}}>
      <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:8,flexWrap:'wrap'}}>
        <h3 style={{margin:0,fontSize:15,color:'#1B3A5C'}}>부가서비스</h3>
        {canEdit && <button className="btn btn-blue btn-sm" onClick={startAdd}>＋ 추가</button>}
        <div style={{flex:1}} />
      </div>
      <div style={{fontSize:12,color:'#94a3b8',marginBottom:8}}>신청 시 선택 항목으로 노출됩니다. 금액은 요청별로 바꿀 수 있습니다.</div>

      <div style={{background:'#fff',border:'1px solid #e2e8f0',borderRadius:12,overflow:'hidden'}}>
        <table style={{width:'100%',borderCollapse:'collapse',fontSize:13}}>
          <thead>
            <tr>
              <th style={TH}>이름</th>
              <th style={Object.assign({},TH,{textAlign:'right'})}>기본 금액</th>
              <th style={TH}>계산서</th>
              <th style={TH}>사용</th>
              <th style={Object.assign({},TH,{textAlign:'right'})}>순서</th>
              {canEdit && <th style={Object.assign({},TH,{textAlign:'right'})}>관리</th>}
            </tr>
          </thead>
          <tbody>
            {sorted.map(function(r, idx){
              var editingThis = editing===r.id;
              var tdSt = Object.assign({}, TD, {background: r.active?'#fff':'#f8fafc', opacity: r.active?1:0.7});
              return (<React.Fragment key={'x'+r.id}>
                <tr>
                  <td style={tdSt}>{r.name}</td>
                  <td style={Object.assign({},tdSt,{textAlign:'right'})}>{fmt(r.defaultFee)}</td>
                  <td style={tdSt}>{r.issueTaxInvoice ? <span style={{color:'#059669',fontWeight:700}}>포함</span> : <span style={{color:'#94a3b8'}}>-</span>}</td>
                  <td style={tdSt}>{r.active ? <span style={{color:'#059669',fontWeight:700}}>활성</span> : <span style={{color:'#94a3b8'}}>비활성</span>}</td>
                  <td style={Object.assign({},tdSt,{textAlign:'right',whiteSpace:'nowrap'})}>
                    {canEdit && <React.Fragment>
                      <button className="btn btn-outline btn-sm" disabled={idx===0} onClick={function(){move(r,-1)}} title="위로">▲</button>
                      <button className="btn btn-outline btn-sm" disabled={idx===sorted.length-1} onClick={function(){move(r,1)}} title="아래로" style={{marginLeft:4}}>▼</button>
                    </React.Fragment>}
                  </td>
                  {canEdit && <td style={Object.assign({},tdSt,{textAlign:'right',whiteSpace:'nowrap'})}>
                    <button className="btn btn-outline btn-sm" onClick={function(){editingThis?closeAll():startEdit(r);}}>{editingThis?'닫기':'수정'}</button>
                    <button className="btn btn-outline btn-sm" style={{marginLeft:4}} onClick={function(){setActive(r,!r.active)}}>{r.active?'비활성':'다시 활성'}</button>
                  </td>}
                </tr>
                {editingThis && form && (<tr key={'e'+r.id}>
                  <td colSpan={canEdit?6:5} style={{background:'#fff',padding:0,borderBottom:'1px solid #e2e8f0'}}>
                    <div style={{borderLeft:'3px solid #2563EB',padding:'14px 18px',display:'flex',flexDirection:'column',gap:12}}>
                      {editFields(r)}
                    </div>
                  </td>
                </tr>)}
              </React.Fragment>);
            })}
            {sorted.length===0 && <tr><td colSpan={canEdit?6:5} style={{textAlign:'center',color:'#94a3b8',padding:'30px 0'}}>등록된 부가서비스가 없습니다.</td></tr>}
          </tbody>
        </table>
      </div>

      {add && (<div style={modalWrap} onClick={function(){setAdd(null)}}>
        <div style={modalBox} onClick={function(e){e.stopPropagation()}}>
          <h3 style={{margin:'0 0 14px',fontSize:15,color:'#1B3A5C'}}>부가서비스 추가</h3>
          <div style={frmSt}>
            {fld('이름', textIn(add.name, function(v){setA('name',v)}, '예: 번호판 폐기'))}
            {fld('기본 금액(원)', textIn(add.defaultFee, function(v){setA('defaultFee',v)}, '0', true), 130)}
          </div>
          <label style={{display:'flex',alignItems:'center',gap:6,fontSize:12.5,marginTop:10}}>
            <input type="checkbox" checked={!!add.issueTaxInvoice} onChange={function(e){setA('issueTaxInvoice',e.target.checked)}} /> 계산서 포함
          </label>
          <div style={{display:'flex',gap:8,alignItems:'center',marginTop:14}}>
            <div style={{flex:1}} />
            <button className="btn btn-outline btn-sm" onClick={function(){setAdd(null)}}>취소</button>
            <button className="btn btn-blue btn-sm" onClick={submitAdd}>추가</button>
          </div>
        </div>
      </div>)}

      {del && (<div style={modalWrap} onClick={function(){setDel(null)}}>
        <div style={Object.assign({},modalBox,{width:420})} onClick={function(e){e.stopPropagation()}}>
          <h3 style={{margin:'0 0 4px',fontSize:15,color:'#1B3A5C'}}>"{del.name}" 을(를) 삭제할까요?</h3>
          <p style={{fontSize:12,color:'#64748b',margin:'0 0 14px'}}>이미 요청에 반영된 항목은 그대로 남고, 목록에서만 사용 중지됩니다.</p>
          <div style={{display:'flex',gap:8,alignItems:'center'}}>
            <div style={{flex:1}} />
            <button className="btn btn-outline btn-sm" onClick={function(){setDel(null)}}>취소</button>
            <button className="btn btn-outline btn-sm" style={{color:'#dc2626'}} onClick={doDelete}>삭제</button>
          </div>
        </div>
      </div>)}
    </div>
  );
}

export default CancelAgencyExtraServices;
